/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>账户管理</el-breadcrumb-item>
      <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.walletName" placeholder="输入钱包名称"></el-input>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
        <el-select v-model="formInline.depId" placeholder="请选择部门" size="small" @change="getData">
          <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>




      <el-form-item>
        <el-button size="small" type="success" @click="handelAdd">添加</el-button>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;" :row-class-name="tableRowClassName" :header-cell-style="this.$store.state.headerCss">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column prop="walletName" label="名称" width="200" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="totalMoney" width="130" label="历史充值总金额" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="balance" label="余额" width="120" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="用户" width="140" sortable >
        <template slot-scope="scope">
          <el-tag style="margin-right: 4px;" v-for="item in  scope.row.appletUserNames" size="mini" type="success" >{{item}}</el-tag>

        </template>
      </el-table-column>
      <el-table-column label="计量点"  >
        <template slot-scope="scope">
          <el-tag style="margin-right: 4px;" v-for="item in scope.row.meterInfoNames" size="mini"  >{{item}}</el-tag>

        </template>
      </el-table-column>
      <el-table-column label="状态" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <el-tag size="mini" type="success" v-if="scope.row.status == 1">正常</el-tag>
          <el-tag size="mini" type="danger" v-if="scope.row.status == 2">冻结</el-tag>
        </template>
      </el-table-column>


      <el-table-column align="center" label="操作" width="420">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="success" @click="handelBindUser(scope.row)">绑定用户</el-button>
          <el-button size="mini" type="success" @click="handelBindMeter(scope.row)">绑定计量点</el-button>
          <el-button size="mini" type="primary" @click="handleRecharge(scope.row,'充值')">充值</el-button>
          <el-button size="mini" type="warning" @click="handleRecharge(scope.row,'退款')">退款</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather"></Pagination>


    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" @click="closeDialog('editForm')" width="600px" :close-on-click-modal="false">
      <el-form label-width="80px" :model="editForm" ref="editForm"  :rules="erules">


        <el-form-item v-if="user.username == 'admin'" label="选择部门">
          <el-select v-model="editForm.departmentId" placeholder="请选择部门" size="small" @change="deptChange">
            <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="钱包名称" prop="walletName">
          <el-input size="small" v-model="editForm.walletName" auto-complete="off" placeholder="请输入钱包名称"></el-input>
        </el-form-item>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">确认</el-button>
      </div>
    </el-dialog>


    <!-- 绑定用户界面 -->
    <el-dialog title="绑定用户" :visible.sync="usersFormVisible" width="50%" :close-on-click-modal="false">
      <el-button size="small" type="primary" @click="handelBindUserAdd">添加</el-button>
      <el-button type="danger" size="small" :disabled="delCuses.length == 0 " @click="deleteUser">解除绑定</el-button>
      <div style="padding: 10px 0;">当前绑定用户</div>
      <el-table size="small" :data="cusers" @selection-change="getDelUserIds" :header-cell-style="this.$store.state.headerCss"
        v-loading="loadingUser" border element-loading-text="拼命加载中" style="width: 100%;" stripe>
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>

        <el-table-column prop="userName" label="用户账号">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码">
        </el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="usersFormVisible = false">取消</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="saveUsers">确认</el-button> -->
      </div>
    </el-dialog>


    <!-- 绑定计量点界面 -->
    <el-dialog title="绑定计量点" :visible.sync="meterFormVisible" width="50%" :close-on-click-modal="false">
      <el-button size="small" type="primary" @click="handeMetersAdd">添加</el-button>
      <el-button type="danger" size="small" :disabled="delMeters.length == 0 " @click="delFnMeters">解除绑定</el-button>
      <div style="padding: 10px 0;">当前绑定计量点</div>
      <el-table size="small" height="400" :data="cmeters" @selection-change="getDelMeterIds" :header-cell-style="this.$store.state.headerCss"
        v-loading="loadingUser" border element-loading-text="拼命加载中" style="width: 100%;" stripe>
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column prop="meterId" label="id">
        </el-table-column>
        <el-table-column prop="meterName" label="计量点名称">
        </el-table-column>
        <el-table-column prop="meterPoint" label="计量点地址">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="meterFormVisible = false">取消</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="saveMeters('editForm')">确认</el-button> -->
      </div>
    </el-dialog>

    <!-- 充值退款 -->
    <el-dialog :title="rtitle" :visible.sync="rechargeFormVisible" width="30%" @click="closeDialog" :close-on-click-modal="false">
      <el-form label-width="120px" :model="reditForm" :rules="crules" ref="reditForm">

        <el-form-item label="钱包名称:">
          <div>{{wName}}</div>
        </el-form-item>
        <el-form-item label="当前余额:">
          <div>{{cbalance}}</div>
        </el-form-item>

        <el-form-item label="交易类型">
          <el-select size="small" v-model="reditForm.transType">
            <el-option v-for="type in payType" :label="type.label" :value="type.value" :key="type.value" v-if="rtitle != '退款' || type.value !='8'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易用户" prop="appletId">
          <div v-if="cusers.length">
            <el-radio v-model="reditForm.appletId" :label="item.id" v-for="item in cusers" :key="item.id">{{item.userName}}</el-radio>
          </div>
          <el-tag v-if="cusers.length == 0" size="mini" type="danger">还未绑定用户</el-tag>
        </el-form-item>
        <el-form-item label="充值金额" prop="totalFee" v-if="rtitle == '充值'">
          <el-input size="small" v-model="totalFee" type="number" placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <el-form-item label="退款金额" prop="totalFee" v-if="rtitle == '退款'">
          <el-input size="small" v-model="totalFee" type="number" placeholder="请输入退款金额"></el-input>
        </el-form-item>


        <el-form-item label="交易备注">
          <el-input type="textarea" r autosize placeholder="请输入备注" v-model="reditForm.mark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="rechargeFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saveLoad" :disabled="cusers.length == 0" class="title" @click="subRechargeForm('reditForm')">保存</el-button>
      </div>
    </el-dialog>


    <!-- 添加用户界面 -->
    <el-dialog title="新增绑定用户" :visible.sync="addBindUserFormVisible" width="36%" @click='addFormVisible = false' :close-on-click-modal="false">
      <el-input size="small" v-model="searchDatas" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input>
      <el-table size="small" :data="userTables" height="500px" @selection-change="handleSelectionChange" ref='bindUsersTable'
        v-loading="loadMeter">
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="id" prop="id" width="100"></el-table-column>
        <el-table-column label="用户" prop="username"></el-table-column>
        <el-table-column label="手机号码" prop="phoneNumber" width="200"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='addBindUserFormVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveUsers">确认</el-button>
      </div>
    </el-dialog>

    <!-- 添加计量点界面 -->
    <el-dialog title="新增绑定计量点" :visible.sync="addBindMeterFormVisible" width="36%" @click='addFormVisible = false' :close-on-click-modal="false">
      <el-input size="small" v-model="searchMeters" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input>
      <el-table size="small" :data="meterTables" height="500px" @selection-change="handleMeterChange" ref='bindUsersTable'
        v-loading="loadMeter">
        <el-table-column type="selection"></el-table-column>
        <el-table-column label="id" prop="id" width="100"></el-table-column>
        <el-table-column label="计量点名称" prop="meterPointName"></el-table-column>
        <el-table-column label="计量点地址" prop="meterPoint" width="200"></el-table-column>

      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='addBindMeterFormVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveMeters">确认</el-button>
      </div>
    </el-dialog>




  </div>
</template>

<script>
  import {
    walletAdd,
    appletUserList,
    walletSelectByDptId,
    userBindWallet,
    findUsersById,
    findAppletUserBindingWallet,
    findMeterInfoBindingWallet,
    MeterInfoBindingWallet,
    findMeterInfosById,
    invest,
    deduction,
    walletUpdate
  } from '../../api/payMG'
  import {
    getDepartmentTerminalInfoLis,
    getDepartmentIdByMeterInfos
  } from '../../api/energyMG'

  import Pagination from '../../components/Pagination'
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (this.totalFee == "") {
          let msg = this.rtitle == '充值' ? '请输入充值金额' : '请输入退款金额'
          callback(new Error(msg));
        } else {
          if (this.rtitle == '退款') {
            if (this.totalFee > this.reditForm.blance) {
              return callback(new Error('退款金额不能大于当前余额'));
            }
          }
          callback();
        }
      };
      return {
        loadMeter: false,
        addBindUserFormVisible: false,
        user: {},
        setLoading: false,
        searchDatas: "",
        reditForm: {
          amount: 0,
          walletId: "",
          appletId: "",
          transType: '1',
          mark: "",
        },
        wid: '',
        addBindMeterFormVisible: false,
        saveLoad: false,
        loading: false, //是显示加载
        usersFormVisible: false,
        meterFormVisible: false,
        rechargeFormVisible: false,
        loadingUser: false,
        wName: "",
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '',
        rtitle: '充值',
        userList: [],
        meterList: [],
        totalFee: 0,
        editForm: {
          walletName: "",
          totalMoney: 0,
          balance: 0,
          status: 1,
          departmentId: ""
        },
        usersFormInline: {
          currentPage: 1,
          pageSize: 999999,
          username: "",
          meterPointName: "",
          phoneNumber: "",
          departmentId: '',
        },
        formInline: {
          depId: '',
          currentPage: 1,
          pageSize: 10,
          total:0,
          walletName: "",
        },
        payType: [{
            value: '2',
            label: "转账"
          },
          {
            value: '3',
            label: "POS"
          },
          {
            value: '8',
            label: "多还少补"
          },
          {
            value: '7',
            label: "其他"
          },
          {
            value: '1',
            label: "现金"
          },
          {
            value: '4',
            label: "支付宝"
          },
          {
            value: '5',
            label: "微信"
          },
        ],
        cusers: [],
        cmeters: [],
        tempCuserIds: [],
        tempCmeterIds: [],

        delCuses: [],
        delMeters: [],
        cbalance: 0,
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        bindUserForm: {
          walletId: "",
          appletUserIds: "",
        },
        bindMeterForm: {
          walletId: "",
          meterIds: "",
        },
        deptList: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        searchMeters: "",
        crules: {
          totalFee: [{
            validator: validatePass,
            trigger: 'blur'
          }],

          appletId: [{required: true,message: '请选择交易用户',trigger: 'change'}],
        },
        erules:{
          walletName: [{required: true,message: '请输入钱包名称',trigger: 'blur'}],
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.formInline.depId = this.user.departmentId
      this.editForm.departmentId = this.user.departmentId
      this.getData()
      this.getJzData()
    },

    computed: {
      userTables() {
        let search = this.searchDatas
        if (search) {
          return this.userList.filter(data => {
            return Object.keys(data).some(key => {
              return String(data[key]).toLowerCase().indexOf(search) > -1
            })
          })
        }
        return this.userList
      },

      meterTables() {
        let search = this.searchMeters
        if (search) {
          return this.meterList.filter(data => {
            return Object.keys(data).some(key => {
              return String(data[key]).toLowerCase().indexOf(search) > -1
            })
          })
        }
        return this.meterList
      }

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

      getDelUserIds(e) {
        this.delCuses = e.map(item => item.id)
      },

      getDelMeterIds(e) {
        this.delMeters = e.map(item => item.meterId)
      },

      deleteUser() {
        let arr = []
        this.cusers.forEach(item => {
          if (!(this.delCuses.indexOf(item.id) > -1)) {
            arr.push(item)
          }
        })

        this.bindUserForm.appletUserIds = arr.map(item => item.id).join('-')
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.bindUsers()
          })

      },

      delFnMeters() {
        let arr = []
        this.cmeters.forEach(item => {
          if (!(this.delMeters.indexOf(item.meterId) > -1)) {
            arr.push(item)
          }
        })

        this.bindMeterForm.meterIds = arr.map(item => item.meterId).join('-')
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            this.bindMeters()
          })
      },



      handelBindUserAdd() {
        this.addBindUserFormVisible = true
        this.userTables = ''
        this.tempCuserIds = []

        this.$nextTick(() => {
          this.$refs.bindUsersTable.clearSelection();
        })


      },

      handeMetersAdd() {
        this.addBindMeterFormVisible = true
        this.searchMeters = ''
        this.tempCmeterIds = []
        this.$nextTick(() => {
          this.$refs.bindUsersTable.clearSelection();
        })
      },



      subRechargeForm(editData) {

        this.$refs[editData].validate(valid => {
          if (valid) {
            this.$confirm('确定执行' + this.rtitle + '操作吗?', '信息', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {


              if (this.rtitle == "充值") {
                this.rayCheck()
              } else {
                this.brefund();
              }
            })
          } else {
            return false
          }
        })
      },
      rayCheck() {
        this.saveLoad = true
        this.rtitle = "充值"
        let uName = this.cusers.filter(item => item.id == this.reditForm.appletId)[0].userName

        let param = {
          appletId: this.reditForm.appletId,
          amount: this.totalFee,
          walletId: this.reditForm.walletId,
          transType: this.reditForm.transType,
          mark: this.reditForm.mark,
          appletName: uName
        }


        invest(param).then(res => {
            this.saveLoad = false
            if (res.status == 1) {
              this.rechargeFormVisible = false
              this.getData()
              this.$message({
                type: 'success',
                message: '充值成功！'
              })
            } else {
              this.rechargeFormVisible = false
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.rechargeFormVisible = false
            this.saveLoad = false
            this.$message.error('操作失败，请稍后再试！')
          })
      },

      brefund() {
        this.saveLoad = true
        this.rtitle = "退款"
        let uName = this.cusers.filter(item => item.id == this.reditForm.appletId)[0].userName
        let param = {
          appletId: this.reditForm.appletId,
          amount: this.totalFee,
          walletId: this.reditForm.walletId,
          transType: this.reditForm.transType,
          mark: this.reditForm.mark,
          appletName: uName
        }
        deduction(param).then(res => {
            this.saveLoad = false
            if (res.status == 1) {
              this.rechargeFormVisible = false
              this.getData()
              this.$message({
                type: 'success',
                message: '退款成功！'
              })
            } else {
              this.rechargeFormVisible = false
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.rechargeFormVisible = false
            this.saveLoad = false
            this.$message.error('操作失败，请稍后再试！')
          })
      },
      handleRecharge(row, title) {
        this.wName = row.walletName
        this.rtitle = title
        this.rechargeFormVisible = true
        this.reditForm.walletId = row.id
        this.cbalance = row.balance
        this.totalFee = ''
        this.reditForm.mark = ''


        this.getBindUsers(row.id).then(res=> {
            if(res.id){
              this.reditForm.appletId = res.id
            }
        })

      },


      handelBindUser(row) {
        this.usersFormVisible = true
        this.loadingUser = true
        this.usersFormInline.departmentId = row.departmentId
        this.bindUserForm.walletId = row.id
        this.getBindUsers(row.id)
        this.wid = row.id
        appletUserList(this.usersFormInline).then(res => {
          this.loadingUser = false
          if (res.status == 1) {
            this.userList = res.data.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })

      },

      getBindUsers(id) {


        return new Promise((resolve, reject) => {
          findUsersById({
            id: id
          }).then(res => {
            if (res.status == 1) {
              this.cusers = res.data.data
              resolve(res.data.data[0])
            }
          })
        })

      },


      getBindMeters(id) {
        findMeterInfosById({
          id: id
        }).then(res => {
          if (res.status == 1) {
            this.cmeters = res.data.data
          }
        })
      },


      handelBindMeter(row) {
        this.meterFormVisible = true
        this.bindMeterForm.walletId = row.id
        let parm = {
          depId: row.departmentId
        }

        this.getBindMeters(row.id)
        this.wid = row.id
        getDepartmentIdByMeterInfos(parm).then(res => {
          if (res.status == 1) {
            this.meterList = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      },

      saveUsers() {


        let oldUserList = this.cusers.map(item => item.id)
        let arr = this.tempCuserIds.concat(oldUserList) // 原来绑定的用户id加上新加的用户id
        let newUserList = Array.from(new Set(arr)) //去掉重复ID
        let checkIds = this.tempCuserIds.join('-')

        this.bindUserForm.appletUserIds = newUserList.join('-')


        findAppletUserBindingWallet({
          appletUserIds: checkIds
        }).then(res => {
          if (res.data) {
            this.$confirm(res.data + '是否继续操作？')
              .then(() => {
                this.bindUsers()
              })
              .catch(_ => {});
          } else {
            this.bindUsers()
          }
        })
      },




      bindUsers() {
        userBindWallet(this.bindUserForm).then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功')
            this.addBindUserFormVisible = false
            this.getBindUsers(this.wid)
            this.getData()
          }
        })
      },


      bindMeters() {
        MeterInfoBindingWallet(this.bindMeterForm).then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功')
            this.addBindMeterFormVisible = false
            this.getBindMeters(this.wid)
            this.getData()
          }
        })
      },



      saveMeters() {

        let oldMeterList = this.cmeters.map(item => item.meterId)
        let arr = this.tempCmeterIds.concat(oldMeterList) // 原来绑定的用户id加上新加的用户id
        let newMeterList = Array.from(new Set(arr)) //去掉重复ID
        let checkIds = this.tempCmeterIds.join('-') //当前选择ID 去检查

        console.log(checkIds)

        this.bindMeterForm.meterIds = newMeterList.join('-')

        findMeterInfoBindingWallet({
          meterIds: checkIds
        }).then(res => {
          if (res.data) {
            this.$confirm(res.data + '是否继续操作？')
              .then(() => {
                this.bindMeters()
              })
              .catch(_ => {});
          } else {
            this.bindMeters()
          }
        })
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (row.transType === '退款') {
          return 'warning-row';
        }
        return '';
      },
      handleSelectionChange(e) {
        this.tempCuserIds = e.map(item => item.id)
        // this.bindUserForm.appletUserIds = e.map(item => item.id)


      },

      handleMeterChange(e) {
        this.tempCmeterIds = e.map(item => item.id)
      },





      handelAdd() {
        this.editFormVisible = true
        this.editForm.walletName = ''
        this.title = '添加'
      },

      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.deptList = res.data.menuDepList
            } else {
              this.$message.error(res.msg)
            }
          })
        })
      },


      deptChange(e) {
        this.editForm.departmentId = e
      },


      getData() {
        this.loading = true
        walletSelectByDptId(this.formInline)
          .then(res => {
            this.loading = false
            if (res.status == 1) {
              this.listData = res.data.data
              this.formInline.total = res.data.totalCount
            } else {

            }
          })

      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },
      // 搜索事件
      search() {
        this.getData()
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.title = "编辑"
        this.editFormVisible = true
        this.editForm.walletName = row.walletName
        this.editForm.id = row.id
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            if(this.title == '添加'){
               this.add()
            }else{
              this.update()
            }


          } else {
            return false
          }
        })
      },




      add(){
        walletAdd(this.editForm)
          .then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.status == '1') {

              this.$message({
                type: 'success',
                message: '操作成功！'
              })
              this.getData()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      update(){
        walletUpdate(this.editForm).then(res => {
          if(res.status == 1 ){
            this.$message.success("操作成功！")
            this.getData()
            this.editFormVisible = false
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      },




      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false
        this.$refs[formName].resetFields()
      }


    }
  }
</script>

<style scoped>
  .user-search {}

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/wallet.vue